import { AnalyticsInterface } from "./types";

export function waitForAnalyticsModule() {
  return new Promise<AnalyticsInterface>((resolve) => {
    let timeout = null;
    function poll() {
      clearTimeout(timeout);
      if (window.analytics?.analytics === undefined) {
        timeout = setTimeout(poll, 10);
      } else {
        window.analytics.ready.then(() => {
          resolve(window.analytics);
        });
      }
    }
    poll();
  });
}
